
              <template>


  <div class="users">
            <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
      <span>Awesome! You added a new User.</span>
      <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <div class="hidden-sm-and-down">
        <h1 class="Header">Users</h1>
    </div>

    <v-snackbar v-model="profilephotofilesnackbar" :timeout="4000" top color="success">
      <span>Awesome! Data saved successfully.</span>
      <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>

<!-- <v-layout row>
<v-card v-for="user in UsersFilteredandSearched" :key="user.id"
    class="mx-auto"
    max-width="434"
    tile
  >
    <v-img
      height="100%"
      src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg"
    >
     <v-card
                  class="mx-auto"
                  max-width="434"
                  tile
                  dark
                   color="rgba(60, 60, 60, 0.9)"
                >
      <v-row
        align="end"
        class="fill-height"
      >
        <v-col
          align-self="start"
          class="pa-0"
          cols="12"
        >
          <v-avatar
            class="profile"
            color="grey"
            size="164"
            tile
          >
            <v-img :src="user.profilephoto"></v-img>
          </v-avatar>
        </v-col>
        <v-col class="py-0">
          <v-list-item
            color="rgba(0, 0, 0, .4)"
            dark
          >
            <v-list-item-content>
              <v-list-item-title class="title">{{user.Full_Name}}</v-list-item-title>
              <v-list-item-subtitle>{{user.Title}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
     </v-card>
    </v-img>
  </v-card>
</v-layout> -->


<v-data-table
    :headers="headers"
    :items="UsersFilteredandSearched"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>My Users</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field light
          v-model="search"
          append-icon="mdi-file-find-outline"
          label="Search"
          single-line
          hide-details
        ></v-text-field><v-icon @click="ResetSearch()" v-if="search !== ''" class="mx-10">mdi-close</v-icon>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New User</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
            
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-text-field readonly filled v-model="UserFullName" label="FullName"></v-text-field>
                    <v-text-field v-model="editedItem.Name" label="Name"></v-text-field>
                    <v-text-field v-model="editedItem.Surname" label="Surname"></v-text-field>
                    <v-text-field v-model="Email" label="Email"> </v-text-field>
                    <v-text-field v-model="Password" label="Password" type="password"> </v-text-field>
                      <v-select label="Select Title" v-model="editedItem.Title" :items="TitleArray" item-text="Name"> </v-select>                    
                     <v-select label="Select Gender" v-model="editedItem.Gender" :items="GenderArray" item-text="Name"> </v-select>
                      <v-combobox v-if="editedIndex > -1"
                        v-model="editedItem.Manager"
                        :items="ManagerArray"
                        item-text="Full_Name"
                        hide-selected
                        label="Search Manager"
                        small-chips
                        solo
                        flat
                      ></v-combobox>
                  </v-col>
                </v-row>
             
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
<v-dialog v-model="importdialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="green" dark class="mb-2" v-on="on">Import</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Import Dialog</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-text-field v-model="Import.Name" label="Name"></v-text-field>
                    <input v-if="!ImportFile"
                              type="file"
                              @change="onImportfileSelected($event)"
                              ref="ImportFileinputter"
                              id="fileUpload"
                              >
                    <v-btn @click="DownloadUsersImportTemplate()">Download Template</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeImport()">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="saveImport()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>

<v-toolbar v-if="UsersArray" flat dense dark color="primary">
        <v-layout col class="justify-start">
          <h3 class="my-8"> Filters</h3><v-spacer></v-spacer>
        <div width="100px"><br>
          <v-autocomplete class="mx-5"
          :items="ManagerArrayFilter"
          v-model="Managerfilter"
          item-text="Full_Name"
          label="Search Users"
          autowidth
          return-object
          chips
          flat
          />
          </div>
          <v-icon @click="ResetFilters()">mdi-close</v-icon>
          </v-layout>
        </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-trash-can-outline
      </v-icon>
      <v-icon
        small
        @click="ViewItem(item)"
      >
        mdi-eye
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>

  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import format from 'date-fns/format'


export default {
  data() {
    return {
      Title: '',
      Gender: '',
      TitleArray: [
          {index: 0, Name: 'Mr'},
          {index: 1, Name: 'Mrs'},
          {index: 2, Name: 'Ms'},

        ],
        GenderArray: [
          {index: 0, Name: 'Male'},
          {index: 1, Name: 'Female'},

        ],
      profilephotofilesnackbar: false,
      selectedprofilephotoFile: '',
      profilephotolocalURL: '',
      ManagerArray: [],
      Managerfilter: {Full_Name: ''},
      mainrecordid: '',
      dialog: false,
      importdialog: false,
      ImportHeaders: [],
      NewImportsArray: [],
      PartialFailuresArray: [],
      SuccessfulImportsArray: [],
      CSVResult: [],
      Import: {Name: '',AllImports: [],PartialFailures: [], Dataset: 'Contacts', CreatedOn: '', CreatedBy: {id: '', Name: ''}},
      ImportFile: '',
      userimportheaders: [
      
        { text: 'Title', value: 'Title'},
        { text: 'Email', value: 'Email'},
        { text: 'FullName', value: 'Full_Name'},
        { text: 'Name', value: 'Name'},
        { text: 'Surname', value: 'Surname'},
        { text: 'Gender', value: 'Gender'},
        { text: 'Business Unit', value: 'Business_Unit.Name'},
        { text: 'Manager', value: 'Manager.Full_Name'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      UserRecord: '',
      UsersImportArray: [],
      initialize: '',
      search: '',
      headers: [
      
        { text: 'Title', value: 'Title'},
        { text: 'FullName', value: 'Full_Name'},
        { text: 'Name', value: 'Name'},
        { text: 'Surname', value: 'Surname'},
        { text: 'Gender', value: 'Gender'},
        { text: 'Business Unit', value: 'Business_Unit.Name'},
        { text: 'Manager', value: 'Manager.Full_Name'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      snackbar: false,
      EditedUsersnackbar: false,
      UserEditdialog: false,
      newUserdialog: false,
      UsersArray: [],
      editedIndex: -1,
      defaultItem: {
        id: '',
          Full_Name: '',
          Name: '',
          Surname: '',
          Business_Unit: {id: '',  Name: ''},
          Manager: {id: '',  Full_Name: ''},
          profilephoto: '',
      },
      editedItem: {
        id: '',
          Full_Name: '',
          Name: '',
          Surname: '',
          Business_Unit: {id: '',  Name: ''},
          Manager: {id: '',  Full_Name: ''},
          profilephoto: '',
      },
      Email: '',
      Password: '',
    }
  },

  created(){
this.GetRequestingUser()
    

  },
  computed: {
    UserFullName(){
      return this.editedItem.Name+' '+this.editedItem.Surname
    },
    FinalUsersManagerArray(){
      return this.UsersArray.map(User => {
        let lookupobject = this.ManagerArray.find(Manager => Manager.id === User.Managerid)
        User.Manager = lookupobject
        return User
      })
      },

    formTitle () {
        return this.editedIndex === -1 ? 'New User' : 'Edit User'
      },
    UsersSearched() {
      return this.UsersArray.filter(User => {
        if(this.search !== ''){
        if(User.Full_Name){return User.Full_Name.toLowerCase().includes(this.search.toLowerCase())}
        }
        else {
          return User
        }
      })
      },
      UsersFilteredandSearched() {
      return this.UsersSearched.filter(User => {if(this.Managerfilter.Full_Name){if(User.Manager.Full_Name){ return User.Manager.id.includes(this.Managerfilter.id)}} else {return User}})
      },
        
        ManagerArrayFilter(){
          return this.UsersArray.map(User => {
            return User.Manager
          })
        },
        HeaderNames() {
        return this.userimportheaders.map(header => {
          return header.value.split('.')[0]
        }).filter(header => {
          return header !== 'id'
        })
      },
      HeaderNamesSplit() {
        return this.HeaderNames.map(header => {
         let correctheader = header
          return correctheader
        })
      }
    },
  methods: {
    async GetRequestingUser(){
        var vm = this;
      await firebase.auth().onAuthStateChanged(function(user) {
        if (user) {

            db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              vm.GetUsers()
              

              vm.GetManagerArray()            
            })
           
          }
      else {
        vm.RoutetoLoginPage()
          }
          })
      },
    RoutetoLoginPage(){
        this.$router.push('/login')
      },
      RoutetoErrorPage(){
        this.$router.push('/PermissionError')
      },
    closeImport(){
      this.importdialog = false
      this.ImportFile = null
      this.Import.Name = ''
    },

    saveImport() {
      let importLocalURL = URL.createObjectURL(this.ImportFile)
      var reader = new FileReader();
      let test = reader.readAsText(this.ImportFile);
      let vm = this
      reader.addEventListener('load', function(e) {
            var text = e.target.result;
            vm.CSVConvertToJSON(text)
      });
    },


    CheckDelimiter(lines){
      let headertest = lines[0].split(',');
      if(headertest.length ===1){
        this.ConversionCSVtoJJSON(lines,';')
      }
      else{
        this.ConversionCSVtoJJSON(lines, ',')
      }
      console.log('headertest')
      console.log(headertest)
    },
    ConversionCSVtoJJSON(lines,delimiter){
      let dataonly = Object.assign([],lines)
      dataonly.splice(0,1)
      console.log('used '+delimiter)
      console.log(dataonly)
      this.CSVResult = []
      this.ImportHeaders=lines[0].split(delimiter);
      console.log('this.ImportHeaders')
      console.log(this.ImportHeaders)
      for(var i=1;i-1+2<lines.length;i++){

      var obj = {};
      var currentline=lines[i].split(delimiter);
      
      for(var j=0;j<this.ImportHeaders.length;j++){
        obj[this.ImportHeaders[j]] = currentline[j];
      }
      let resultcheck = this.CSVResult.find(res => res.Full_Name == obj.Full_Name)
      this.CSVResult.push(obj);
      console.log("this.CSVResult length is "+this.CSVResult.length)


    }
      this.CSVResult.map(async (res,i) => {
        // await this.sleep(1000)
        this.UpdateFiresStore(res,i)
        
      })
    },
    CSVConvertToJSON(text){
     
      this.NewImportsArray = []
      this.PartialFailuresArray = []
      
      let lines = text.split("\n")
      this.CheckDelimiter(lines)
      
    },
    
    sleep(millis) {
    return new Promise(resolve => setTimeout(resolve, millis));
    },
    UpdateFiresStore(SingleResult, Index){
      
      console.log("Index")
      console.log(Index)
      let ResultLength = this.CSVResult.length
      console.log("ResultLength")
      console.log(ResultLength)
      console.log("Index-1+2")
      console.log(Index-1+2)
      let OriginalImportObject = Object.assign({},SingleResult)
      let ImportUser = {
        Full_Name: SingleResult.Name+' '+SingleResult.Surname,
        Email: SingleResult.Email.toLowerCase(),
        Name: SingleResult.Name,
        Surname: SingleResult.Surname,
        }
        if(SingleResult.Title){
          ImportUser.Title = SingleResult.Title
        }
        if(SingleResult.Gender){
          ImportUser.Gender = SingleResult.Gender
        }

        let FailureObject = Object.assign({},ImportUser)
        FailureObject.Failures = []


        if(SingleResult.Business_Unit !== ''){
          let GetObj = this.BusinessUnitArray.find(comp => comp.Name.toLowerCase() == SingleResult.Business_Unit.toLowerCase())
          if(typeof GetObj === 'undefined'){
            FailureObject.Business_Unit = 'Failed - No Matching Record Found'
            ImportUser.hasFailures = true
            let FailureInstance = {Type: 'No Matching Lookup Record', Name: 'Business_Unit'}
            FailureObject.Failures.push(FailureInstance)
          }
          else{
          let Business_UnitObject = {id: GetObj.id,Name: GetObj.Name}
          ImportUser.Business_Unit = Business_UnitObject
          ImportUser.Business_Unitid = Business_UnitObject.id
          }

        }          

        if(ImportUser.hasFailures){
        this.PartialFailuresArray.push(FailureObject)

        }
        else{
          this.SuccessfulImportsArray.push(OriginalImportObject)
        }

        this.NewImportsArray.push(OriginalImportObject)
        // db.collection('contacts').add(ImportUser).then({
        // })
        this.$store.dispatch('signUpbyAdminImportAction', ImportUser).then(response => {
          console.log('store response promise n users')
          // console.log(response)
          // console.log(response.user)
          // console.log(response.user.uid)
          let UserDataObjtect = {
              Name: ImportUser.Name,
              Surname: ImportUser.Surname,
              Full_Name: ImportUser.Full_Name,
              Gender: ImportUser.Gender,
              Title: ImportUser.Title,
              Email: ImportUser.Email,
              Business_Unit: ImportUser.Business_Unit,
              Business_Unitid: ImportUser.Business_Unitid,
              SubordinateArrayDBrules:{[response.user.uid]: true},
              Subordinatearrayquery: [response.user.uid],
              uid: response.user.uid
            }
            console.log('UserDataObjtect')
            console.log(UserDataObjtect)
          this.UsersImportArray.push(UserDataObjtect)
          let AllImportObj = this.NewImportsArray.find(imp => imp.Full_Name == ImportUser.Full_Name)
          if(typeof AllImportObj !== 'undefined'){
          let AllImportObjIndex = this.NewImportsArray.indexOf(AllImportObj)
          this.NewImportsArray[AllImportObjIndex].id = response.user.uid
          console.log(this.NewImportsArray[AllImportObjIndex])
          console.log(this.NewImportsArray)
          }
          let PartialImportObj = this.PartialFailuresArray.find(imp => imp.Full_Name == ImportUser.Full_Name)

          if(typeof PartialImportObj !== 'undefined'){
          let PartialImportObjIndex = this.PartialFailuresArray.indexOf(PartialImportObj)
          this.PartialFailuresArray[PartialImportObjIndex].id = response.user.uid
          console.log(this.PartialFailuresArray[PartialImportObjIndex])
          console.log(this.PartialFailuresArray)
          }
          let SuccessImportObj = this.SuccessfulImportsArray.find(imp => imp.Full_Name == ImportUser.Full_Name)
          if(typeof SuccessImportObj !== 'undefined'){
          let SuccessmportObjIndex = this.SuccessfulImportsArray.indexOf(SuccessImportObj)
          this.SuccessfulImportsArray[SuccessmportObjIndex].id = response.user.uid
          console.log(this.SuccessfulImportsArray[SuccessmportObjIndex])
          console.log(this.SuccessfulImportsArray)
          }
          if (this.UsersImportArray.length === ResultLength){
        console.log("NewImportsArray")
        console.log(this.NewImportsArray)
        console.log("PartialFailuresArray")
        console.log(this.PartialFailuresArray)
        this.SaveUserArray()
        let CreatedOn = format(new Date(),'yyyy-MM-dd')
        let User = this.UserRecord
        let RefinedHeaders = this.ImportHeaders.map(header => {
          let obj = {text: header, value: header}
          return obj
        })
        console.log("this.NewImportsArray at final length")
        console.log(this.NewImportsArray)
        let DataImport = {name: this.Import.Name, dataset: 'Users', datasetrecordpath: 'User', createdon: CreatedOn, createdby: {id: User.id, Full_Name: User.Name+' '+User.Surname}, importheaders: RefinedHeaders, allimports: this.NewImportsArray, partialfailures: this.PartialFailuresArray, successfulimports: this.SuccessfulImportsArray, dataimportstatus: 'Imported'}
        db.collection('dataimports').add(DataImport).then(doc => {
        var storageRef = firebase.storage().ref('DataImport/'+CreatedOn+'/'+this.ImportFile.name);
        var uploadTask = storageRef.put(this.ImportFile);
        uploadTask
        .then(snapshot => snapshot.ref.getDownloadURL())
          .then((url) => {
            db.collection('dataimports').doc(doc.id).update({
                    csvfile: url
            })
            this.ImportFile = ''
                }),
                  this.importsnackbar = true
        })

        }

        })
    },

    SaveUserArray(){
     let length = this.UsersImportArray.length
      this.UsersImportArray.map((user,i) => {
          if(i-1+2 === length){
            this.saveOnebyOne(user,true)
          }
          else{
            this.saveOnebyOne(user,false)
          }
          
      })
    },

    saveOnebyOne(user,boolean){
      db.collection('users').doc(user.uid).set({
        Name: user.Name,
        Surname: user.Surname,
        Full_Name: user.Full_Name,
        Gender: user.Gender,
        Title: user.Title,
        Email: user.Email,
        Business_Unit: user.Business_Unit,
        Business_Unitid: user.Business_Unitid,
        SubordinateArrayDBrules:{[user.uid]: true},
        Subordinatearrayquery: [user.uid]
      })
      if(boolean){
        this.closeImport()
      }
    },
    onImportfileSelected(event){
      this.ImportFile = event.target.files[0]
    },

    DownloadUsersImportTemplate(){
      let copyText = this.HeaderNamesSplit

      var csvfilename = 'Users.csv'
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(copyText))
      element.setAttribute('download', csvfilename)
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      // }
    },

    ResetFilters() {

      this.Managerfilter = {Full_Name: ''}
    },
    ResetSearch() {
      this.search = ''
    },

    GetUsers() {
      db.collection('users').onSnapshot(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.UsersArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
    })
  },

  onprofilephotoUpload() {
        var storageRef = firebase.storage().ref('User/' + 'profilephoto/'+this.selectedprofilephotoFile.Name);
        var uploadTask = storageRef.put(this.selectedprofilephotoFile);
        uploadTask
        .then(snapshot => snapshot.ref.getDownloadURL())
          .then((url) => {
            db.collection('users').doc(this.mainrecordid).update({
                    profilephoto: url
            })
            this.selectedprofilephotoFile = ''
                }),
                  this.profilephotofilesnackbar = true



      },
      onprofilephotoFileselected(event) {
        this.selectedprofilephotoFile = event.target.files[0]
        this.profilephotolocalURL = URL.createObjectURL(this.selectedprofilephotoFile)
      },



      

      GetManagerArray() {
      db.collection('users').onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.ManagerArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
      //console.log(this.FinalUsersManagerArray)
    })
      },


      ViewItem (item) {
        this.$router.replace('/User/'+item.id)
      },

      deleteItem (item) {
        const index = this.UsersArray.indexOf(item)
        confirm('Are you sure you want to delete this item?') && db.collection('users').doc(item.id).delete() && this.UsersArray.splice(index, 1)
      },

      editItem (item) {
        this.editedIndex = this.UsersArray.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.mainrecordid = item.id
        this.dialog = true
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.mainrecordid = ''
        }, 300)
      },


      save () {
      const EditedUser = {
    Full_Name: this.UserFullName,
    Name: this.editedItem.Name,
    Surname: this.editedItem.Surname,
    Gender: this.editedItem.Gender,
    Title: this.editedItem.Title
        }
      
      if(this.editedItem.Manager){
      EditedUser.Manager= this.editedItem.Manager.Full_Name
      EditedUser.Managerid= this.editedItem.Manager.id
      }
        if (this.editedIndex > -1) {
          this.mainrecordid = this.editedItem.id

      db.collection('users').doc(this.mainrecordid).update({
        Full_Name: EditedUser.Full_Name,
        Name: EditedUser.Name,
        Surname: EditedUser.Surname,
        Gender: EditedUser.Gender,
        Title: EditedUser.Title
        
              });
        if(this.editedItem.Manager){
        db.collection('users').doc(this.mainrecordid).update({
        Manager: {Full_Name: this.editedItem.Manager.Full_Name,id: this.editedItem.Manager.id},
        Managerid: this.editedItem.Manager.id,
        })
        }
              Object.assign(this.UsersArray[this.editedIndex], this.editedItem)
              this.closeUsereditDialog
              this.EditedUsersnackbar = true
        }
         else {
          const NewUser = {
            Full_Name: EditedUser.Full_Name,
            Name: EditedUser.Name,
            Surname: EditedUser.Surname,
            Email: this.Email,
            password: this.Password,
            Title: this.editedItem.Title,
            Gender: this.editedItem.Gender
          }
          
          this.$store.dispatch('signUpbyAdminImportAction', NewUser)
        }
        this.close()
      },

  }
}

</script>
    